var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 88,
    viewBox: "0 0 153 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13595 1.70845L6.14331 1.71024L6.15069 1.71191L89.9461 20.7594C90.0855 20.7998 90.2126 20.8748 90.3155 20.9775C90.4222 21.0841 90.4991 21.2167 90.5386 21.3622C90.5781 21.5077 90.5788 21.661 90.5406 21.8069C90.5024 21.9527 90.4267 22.0861 90.321 22.1935L90.3023 22.2125L90.2847 22.2324L80.5013 33.2996C80.387 33.4108 80.2447 33.4892 80.0894 33.5263C79.9272 33.565 79.7574 33.5571 79.5996 33.5035L79.5815 33.4974L79.5633 33.492L74.8611 32.0947L74.1028 31.8693L73.709 32.5553L66.2343 45.5751L65.7944 46.3414L66.5006 46.8723L69.6005 49.2027C69.8212 49.3979 69.9734 49.6591 70.0343 49.9478C70.0967 50.2437 70.0597 50.5519 69.9291 50.8246C69.9285 50.8258 69.9279 50.8271 69.9273 50.8283L57.9765 74.9737L57.9558 75.0155L57.9391 75.0591C57.8588 75.2684 57.7222 75.4515 57.5445 75.5882C57.3668 75.7249 57.1548 75.8099 56.9319 75.8339C56.7089 75.8578 56.4837 75.8197 56.2811 75.7239C56.0784 75.628 55.9061 75.478 55.7832 75.2905L55.759 75.2537L55.7318 75.2191L2.36636 7.61408L2.36637 7.61407L2.36391 7.61099C1.88332 7.00706 1.60349 6.26803 1.56355 5.49725C1.52362 4.72647 1.72558 3.96248 2.1412 3.31212C2.55681 2.66176 3.16529 2.15756 3.88155 1.87002C4.5978 1.58249 5.38601 1.52599 6.13595 1.70845Z",
    fill: "#3098F3",
    stroke: "#082C4E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0594 45.6955L5.1084 4.75098",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2893 31.7885L5.04102 4.86182",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1914 40.3286C92.0096 45.7184 104.808 54.413 104.076 69.1628C103.809 74.242 97.6434 78.8999 93.163 72.0462C87.9063 64.017 93.4957 48.8014 111.55 54.3021C128.318 59.3148 141.804 72.0462 151.785 86.3967",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineIcon3);
export default __webpack_public_path__ + "static/media/outline-icon3.835a89d4f7c5c35506e7e53c6feca63f.svg";
export { ForwardRef as ReactComponent };